import { __ } from '~/javascripts/lib/locale';

export const STATUS_PAGE_LINK = 'https://status.gitlab.com';
export const CONTACT_SUPPORT_LINK = window.gon.jh
  ? 'https://gitlab.cn/support/'
  : 'https://about.gitlab.com/support/';
export const MANUAL_SUBSCRIPTION_SYNC_DOCS_URL =
  'https://docs.gitlab.com/subscriptions/manage_subscription/#manually-synchronize-subscription-data';
export const LICENSE_ACTIVATION_DOCS_URL =
  'https://docs.gitlab.com/administration/license/#for-offline-environments';
export const CONTACT_US_PATH = '/contact_us';
export const BILLING_ACCOUNT_PATH = '/billing_accounts';
export const SIGN_IN_PATH = '/customers/sign_in';
// Deprecated, use CONTACT_SUPPORT_PLACEHOLDER
// Clean up in https://gitlab.com/gitlab-org/customers-gitlab-com/-/issues/7669
export const DEPRECATED_CONTACT_SUPPORT_PLACEHOLDER = '%{linkStart}contact support%{linkEnd}';

// Allows error string to contain multiple links by more clearly "namespacing" the link placeholder
export const CONTACT_SUPPORT_PLACEHOLDER = `%{supportLinkStart}${__(
  'contact support',
)}%{supportLinkEnd}`;

export const ERROR_FETCHING_DATA_HEADER = __('Could not get the data properly');
export const ERROR_FETCHING_DATA_DESCRIPTION =
  'Please try to refresh the page. If the problem persists, contact support.';
export const ERROR_FETCHING_DATA = `Data could not be retrieved. Please try again. If the problem persists, ${DEPRECATED_CONTACT_SUPPORT_PLACEHOLDER}.`;
export const ERROR_PROCESSING_PAYMENT = `Payment could not be processed. Please try again. If the problem persists, ${DEPRECATED_CONTACT_SUPPORT_PLACEHOLDER}.`;
export const GENERAL_ERROR_MESSAGE = __(
  'Unknown error occurred, this has been logged in our service. Open a Support ticket if the problem persists.',
);
export const UNEXPECTED_ERROR_MESSAGE = `${__(
  'An unexpected error occurred. If the problem persists,',
)} ${CONTACT_SUPPORT_PLACEHOLDER}.`;
export const NETWORK_ERROR_MESSAGE =
  'Something went wrong. Please check your connection and try again.';
export const ERROR_CODE_MAX_SEATS_EXCEEDED = 'MaxAdditionalSeatsExceededError';
export const ERROR_CODE_ZUORA_LOCK = 58730050;
export const DEFAULT_ERROR_CODE = 'NOT_PROVIDED';

export const GITLAB_EE_PLAN = 'gitlab-ee-plan';
export const GITLAB_COM_PLAN = 'gitlab-com-plan';
export const USD_SYMBOL = gon.global?.jh ? '¥' : '$';
export const MIN_VALIDATION_MESSAGE = `Enter a number greater than or equal to %{minValue}`;
export const MIN_SEATS_REASON = __('seats currently in use');

export const OVERAGE_BILLING_LINK = gon.global?.jh
  ? 'https://docs.gitlab.cn/jh/subscriptions/quarterly_reconciliation.html'
  : 'https://docs.gitlab.com/subscriptions/quarterly_reconciliation/';

export const REDUCE_SEATS_LINK = gon.global?.jh
  ? 'https://docs.gitlab.cn/jh/subscriptions/manage_users_and_seats/#reduce-seats'
  : 'https://docs.gitlab.com/subscriptions/manage_users_and_seats/#reduce-seats';

export const PRICING_HELP_LINK_TEXT = __('How pricing works.');
export const GITLAB_CREDITS_PRICING_TEXT_WITH_TERMS_ACCEPTANCE = __(
  'You have accepted on demand billing terms. You are billed for usage beyond monthly credits. The price per credit for monthly credits is based on pricing tiers.',
);
export const GITLAB_CREDITS_PRICING_TEXT_DEFAULT = __(
  'The price per credit for monthly credits is based on pricing tiers. You are billed for usage beyond monthly credits.',
);
export const GITLAB_CREDITS_OVERAGE_BILLING_LINK = gon.global?.jh
  ? 'https://gitlab.cn/pricing/'
  : 'https://about.gitlab.com/pricing/';
export const ROLES_AND_PERMISSIONS_LINK = gon.global?.jh
  ? 'https://docs.gitlab.cn/jh/user/permissions/#roles'
  : 'https://docs.gitlab.com/user/permissions/#roles';

export const GITLAB_PASSWORD_EDIT_URL = gon.global?.jh
  ? 'https://jihulab.com/-/profile/password/edit'
  : 'https://gitlab.com/-/profile/password/edit';

export const COUNTRIES_WITH_STATES_REQUIRED = { USA: 'United States', CAN: 'Canada', CHN: 'China' };
export const COUNTRIES_TO_HIDE_TAX_ID = ['USA'];

export const SOLD_TO_CONTACT = 'soldToContact';
export const BILL_TO_CONTACT = 'billToContact';
export const SOLD_TO = 'sold_to';
export const BILL_TO = 'bill_to';

export const ERROR_CODE_TEAM_PLAN_SEATS_EXCEEDED = 'MaxTeamPlanSeatsExceededError';
export const ERROR_TEAM_PLAN_SEATS_EXCEEDED = __('Subscription exceeds the team plan seats limit');

export const DEFAULT_DEBOUNCE_AND_THROTTLE_MS = 250;
export const ERROR_CODE_REQUEST_CANCELED = 'ERR_CANCELED';
